/**
 * Lazy-load Fancybox for product gallery zoom (P0: jQuery order, onload, click queue).
 */
(function () {
  const config = window.__fancyboxConfig;
  if (!config || !config.js) return;

  let scriptLoaded = false;
  let loading = false;
  let cssInjected = false;
  let pendingTrigger = null;
  let jQueryWaitId = null;
  let interactionTimeout;

  function isFancyboxReady() {
    return typeof jQuery !== 'undefined' && jQuery.fn && typeof jQuery.fn.fancybox === 'function';
  }

  function initFancyBox() {
    document.querySelectorAll('.magnifier-open').forEach((el) => {
      if (!el.getAttribute('data-fancybox')) {
        el.setAttribute('data-fancybox', 'gallery');
      }
      el.classList.remove('hidden');
    });

    if (!isFancyboxReady()) return;

    scriptLoaded = true;
    loading = false;

    if (pendingTrigger) {
      const el = pendingTrigger;
      pendingTrigger = null;
      jQuery(el).trigger('click');
    }
  }

  function injectCss() {
    if (cssInjected || !config.css) return;
    cssInjected = true;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = config.css;
    document.head.appendChild(link);
  }

  function appendFancyboxScript() {
    const script = document.createElement('script');
    script.src = config.js;
    script.onload = function () {
      initFancyBox();
    };
    script.onerror = function () {
      loading = false;
      scriptLoaded = false;
    };
    document.head.appendChild(script);
  }

  function injectScript() {
    if (scriptLoaded || loading) return;

    injectCss();
    loading = true;

    if (typeof jQuery !== 'undefined') {
      appendFancyboxScript();
      return;
    }

    let attempts = 0;
    const maxAttempts = 200;

    if (jQueryWaitId) clearInterval(jQueryWaitId);

    jQueryWaitId = setInterval(function () {
      attempts += 1;
      if (typeof jQuery !== 'undefined') {
        clearInterval(jQueryWaitId);
        jQueryWaitId = null;
        appendFancyboxScript();
      } else if (attempts >= maxAttempts) {
        clearInterval(jQueryWaitId);
        jQueryWaitId = null;
        loading = false;
      }
    }, 50);
  }

  window.openProductGallery = function (triggerEl) {
    if (!triggerEl) return;

    if (isFancyboxReady()) {
      initFancyBox();
      jQuery(triggerEl).trigger('click');
      return;
    }

    pendingTrigger = triggerEl;
    injectScript();
  };

  function onPrefetchInteraction() {
    injectScript();
    if (interactionTimeout) {
      clearTimeout(interactionTimeout);
      interactionTimeout = null;
    }
  }

  document.addEventListener('click', function (e) {
    const magnifier = e.target.closest('a.magnifier-open');
    if (!magnifier || isFancyboxReady()) return;
    e.preventDefault();
    openProductGallery(magnifier);
  });

  // TBT: prefetch only on intentional input (not scroll/mousemove — Lighthouse scroll would pull Fancybox into TBT window)
  document.addEventListener('click', onPrefetchInteraction);
  document.addEventListener('touchstart', onPrefetchInteraction, { passive: true });

  interactionTimeout = setTimeout(function () {
    if (!scriptLoaded && !loading) {
      injectScript();
    }
  }, 40000);
})();
